import type { FC } from 'react';
import { useMemo } from 'react';
import { Box } from '@mui/material';

import type { DashboardWidgetProps } from 'src/types/dashboard';
import useGuidedTour from 'src/components/app/context/GuidedTourContext';
import WidgetGroupItemFrame from 'src/components/dashboard/DashboardPage/components/WidgetGroupItemFrame';
import { DoughnutWidget } from 'src/components/dashboard/DashboardPage/widgets/DoughnutWidget/index';
import useGridSize from 'src/components/dashboard/hooks/useGridSize';

const DoughnutGroupWidget: FC<DashboardWidgetProps> = ({
  config,
  className = '',
}) => {
  const { createStep } = useGuidedTour();
  const gridSize = useGridSize(config);
  const guidedTour = useMemo(
    () => createStep(config.id, config.guided_tour_step),
    [config.guided_tour_step],
  );

  const gridSizeMd = useMemo(
    () => (!config.big_version || Number(gridSize) < 3 ? 6 : gridSize),
    [config.big_version, gridSize],
  );

  const gridSizeLg = useMemo(
    () => (Number(gridSize) < 3 ? 4 : gridSize),
    [gridSize],
  );

  return (
    <>
      {config.questions.map((question, i) => (
        <WidgetGroupItemFrame
          key={i}
          config={config}
          className={className}
          gridSizeMd={gridSizeMd}
          gridSizeLg={gridSizeLg}
          gridSizeXl={gridSize}
          guidedTour={
            !!guidedTour &&
            i < 1 && (
              <Box sx={{ position: 'absolute', zIndex: 1 }}>{guidedTour}</Box>
            )
          }
        >
          <DoughnutWidget
            question={question}
            benchmarkQuestion={config?.benchmark_question}
            bigVersion={!!config.big_version}
            comparisonType={config.comparison_type}
            dataseries={config?.dataseries}
          />
        </WidgetGroupItemFrame>
      ))}
    </>
  );
};

export default DoughnutGroupWidget;
